<template>
	<div class="content">
		<img src="/khqr.png" style="display: none;">
		<img src="/done.png" style="display: none;">
		<div v-if="!loaded" style="width: 100%;height: 100%;display: flex; justify-content: center; align-items: center;position:absolute">
			<loading />
		</div>

		<div v-show="loading" style="z-index: 9999; background-color: rgba(0,0,0, .7); width: 100%;height: 100%;display: flex; justify-content: center; align-items: center;position:absolute">
			<loading />
		</div>

		<div v-if="loaded && submited" style="position: absolute; height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
			<div style="text-align: center; padding: 30px">
				<img src="/done.png" style="width: 20%" />
				<div style="text-align: center;">
					<h3 style="color: #FFF;">ដាក់ស្នើជោគជ័យ!</h3>
					<p style="color: #FFF; line-height: 25px; font-size: 15px;">គម្រោងរបស់អ្នកត្រូវបានដាក់ស្នើដោយជោគជ័យ។ <br>ក្រុមការងារនឹងត្រួតពិនិត្យក្នុងពេលបន្តិចទៀតនេះ។</p>
				</div>
			</div>

		</div>

		<div class="md-layout" v-if="loaded && !submited">
			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>

			<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50" style="margin-bottom: 25px">
				<div style="text-align: center; padding-top: 10px">
					<h3 style="color: #FFF;">ជាវកញ្ចប់ Premium Plan</h3>
					<p style="color: #FFF">ជ្រើសរើសកញ្ចប់ណាមួយដើម្បីអាចមើលបានរឿងទាំងអស់គ្មានដែនកំណត់</p>
				</div>
				<md-card v-for="(plan, index) in planList" style="cursor: pointer;">
					<md-card-content >
						<div @click="selectPlan(plan)" style="display: flex; flex-direction: column; align-items: center; color: #FFF;">
							<div>
								<md-icon :style="'font-size: 32px !important; color: '+colorList[index]">subscriptions</md-icon>
							</div>
							<div class="title" style="margin-top: 15px;font-size:16px"><b>{{plan.name.split("||")[0]}}</b></div>
							<div class="price" style="margin-top:8px; color: #CCC">{{config.moneylify(plan.price)}} / {{plan.duration}} ថ្ងៃ</div>
							<div style="margin-top:12px; display: flex; flex-direction: row; align-items: center; justify-content: left;width:100%">
								<div style="padding: 0 20px"><md-icon :style="'color: ' + colorList[index]">done</md-icon></div>
								<div class="text">វីដេអូមានគុណភាពខ្ពស់</div>
							</div>
							<div style="margin-top:12px; display: flex; flex-direction: row; align-items: center; justify-content: left;width:100%">
								<div style="padding: 0 20px"><md-icon :style="'color: ' + colorList[index+1]">done</md-icon></div>
								<div class="text">មើលគ្មានដែនកំណត់</div>
							</div>
							<div style="margin-top:12px; display: flex; flex-direction: row; align-items: center; justify-content: left;width:100%">
								<div style="padding: 0 20px"><md-icon :style="'color: ' + colorList[index+2]">done</md-icon></div>
								<div class="text">វីដេអូថ្មីៗរៀងរាល់ថ្ងៃ</div>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>
		</div>

		<div v-if="loaded && selected && !submited" style="height:100%; background-color:rgba(0,0,0,0.7); z-index:999;position:fixed; bottom:0px; width: 100%;">
			<div style="height: 100%; width: 100%;position: absolute;" @click="diselect()"></div>
			<div class="selected-content">
				<div class="md-layout" v-if="loaded && selected">
					<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>
					<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">
							<div style="text-align: center;">
								<h3 style="color: #FFF;">ការជាវសង្ខេប</h3>
							</div>
							<div class="section-content">
								<div class="plan-row">
									<span>ឈ្មោះគម្រោង</span>
									<span><b>{{selectedPlan.name.split("||")[0]}}</b></span>
								</div>
								<div class="plan-row" style="border-top: 1px solid #36393e;">
									<span>រយៈពេល</span>
									<span><b>{{selectedPlan.duration}} ថ្ងៃ</b></span>
								</div>
								<div class="plan-row" style="border-top: 1px solid #36393e;">
									<span>តម្លៃ</span>
									<span><b>{{config.moneylify(selectedPlan.price)}}</b></span>
								</div>
								<div class="plan-row" style="border-top: 1px solid #36393e;">
									<span>សរុប</span>
									<span><b>{{config.moneylify(selectedPlan.price)}}</b></span>
								</div>
							</div>
							<div style="text-align: center;">
								<h3 style="color: #FFF;">ការទូទាត់ប្រាក់</h3>
							</div>
							
							<div class="section-content" style="text-align: center; display: flex; flex-direction: row;">
								<div style="width: 50%; padding: 0 5px 0 0">
									<div style="width: 100%">
										<div style="text-align: left;">ABA Bank Name</div>
										<div style="margin-top: 8px;border-radius: 8px; border: 1px solid #36393e; padding: 8px 12px; text-align: left;">Srin MOL</div>
									</div>
									<div style="width: 100%">
										<div style="margin-top: 8px; text-align: left;">Bank Number</div>
										<div style="margin-top:8px; border-radius: 8px; border: 1px solid #36393e; padding: 8px 12px; text-align: left;">008088756</div>
									</div>
								</div>
								<div style="width: 50%; padding: 0 0 0 5px">
									<img :src="'/khqr' + String(selectedPlan.price) + '.png'" style="width: 100%"/>
								</div>
							</div>
							<div style="width: 100%; padding: 5px 0 5px 0">
								<div @click="downloadKHQR()" style="cursor: pointer; margin-top: 8px;width: 100%; background-color: #FFF; border-radius: 8px;margin-top: 8px; color: #333; text-align: center; display: flex; flex-direction: row; padding: 4px 0; align-items: center; justify-content: center;">
									<i class="material-icons">download</i>
									<span style="margin-left: 8px">ទាញយក KHQR</span>
								</div>
							</div>

							<div class="section-content">
								<div>ផ្ទុករូបភាពប្រតិបត្តិការ</div>
								<input type="file" ref="image" accept="image/*" style="display: none;" @change="processFile($event)">
								<!-- <img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.bank_khr.length == 0"> -->
								<div style="text-align: center;">
									<img style="width: 20%" :src="'https://api.sndrama.com/api/v1/admin/transaction-url/' + plan.transaction_url" v-if="plan.transaction_url.length > 0">
								</div>
								<div @click="openFile()" style="cursor: pointer; margin-top: 8px;width: 100%; background-color: #FFF; border-radius: 8px;margin-top: 8px; color: #333; text-align: center; display: flex; flex-direction: row; padding: 4px 0; align-items: center; justify-content: center;">
									<i class="material-icons">cloud_upload</i>
									<span style="margin-left: 8px">ផ្ទុករូបភាព</span>
								</div>
							</div>
							<div class="section-content" style="margin-bottom: 25px;">
								<div style="width: 100%; background-color: rgb(220, 60, 68); border-radius: 8px;padding: 15px 0; text-align: center;margin-top: 25px; cursor: pointer;" @click="request()">ដាក់ស្នើ</div>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>
				</div>
			</div>
		</div>
		
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.access_token = this.$route.params.access_token
			this.getSubscription();
		},

		data() {
			return {
				access_token: "",
				success: false,
				fail: false,
				selected: false,
				selectedPlan: null,
				submited: false,
				loaded: false,
				loading: false,
				planList: [],
				colorList: [
					"#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b", "#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b","#dc3c44", "#4fa747", "#e9b44b"
				],
				plan: {
					subscription_hash: "",
					transaction_url: ""
				}
			}
		},
		methods: {
			getSubscription() {
				if (String(this.$route.params.access_token).length > 10) {
					this.$http.get(this.config.api + "/mobile/subscription", {
						headers: {
							Authorization: 'Bearer ' + this.$route.params.access_token
						}
					}).then(data => {
						if(data.body.status == 'success') {
							console.log(data);
							this.planList = data.body.data;
							this.loaded = true;
						} else {
							this.$router.push('/404');
						}
					})
				} else {
					this.$router.push("/404");
				}
			},
			processFile(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				this.loading = true;
				formData.append("upload", files[0], 'upload');
				this.$http.post(this.config.api + '/mobile/upload-transaction', formData, {
					headers: {
						Authorization: 'Bearer ' + this.$route.params.access_token
					}
				}).then(res => {
					this.loading = false;
					if (res.body.status == 'success') {
						this.plan.transaction_url = res.body.data;
					}
				})
			},
			request() {
				if(this.plan.subscription_hash.length == 0 || this.plan.transaction_url.length == 0) {
					alert("សូមធ្វើការ Upload រូបភាពបញ្ជាក់ប្រតិបត្តិការ ។")
					return true;
				}

				this.loading = true;
				this.$http.post(this.config.api + "/mobile/request-subscription", {
					subscription_hash: this.plan.subscription_hash,
					transaction_url: this.plan.transaction_url
				}, {
					headers: {
						Authorization: 'Bearer ' + this.$route.params.access_token
					}
				}).then(data => {
					this.loading = false;
					if (data.body.status == 'fail') {
						alert(data.body.message);
					} else if (data.body.status == 'success') {
						this.submited = true;
					} else {
						alert("មានបញ្ហា! សូមទាក់ទងក្រុមការងារ។");
					}
				})
			},

			downloadKHQR() {
				window.open("https://subscribe.sndrama.com/khqr" + String(this.selectedPlan.price) + ".png", '_blank');
			},

			selectPlan(plan) {
				this.selected = true;
				this.selectedPlan = plan;
				this.plan.subscription_hash = plan.hash;
			},
			diselect() {
				this.selected = false;
				this.selectedPlan = null;
				this.plan.transaction_url = "";
				this.plan.subscription_hash = "";
			},
			openFile() {
				this.$refs['image'].click();
			},
			
		}
	}
</script>
<style>
	.plan-icon {

	}
	.plan-row {
		display: flex;
		flex-direction: row; 
		justify-content: space-between;
		padding: 8px 0;
	}
	.selected-content {
		background-color: #282b30 !important; 
		bottom: 0px; 
		position: absolute;
		width: 100%; 
		border-top-left-radius: 20px; 
		border-top-right-radius: 20px;
	}
	.section-content {
		width: 100%;
		padding: 5px 10px 0 10px; 
		color: #FFF;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Auth.vue